import { render, staticRenderFns } from "./AddressDetail.vue?vue&type=template&id=5c8934e9&"
import script from "./AddressDetail.vue?vue&type=script&lang=ts&"
export * from "./AddressDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports